import { Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/shell.js';
import { DashboardPage } from './pages/dashboard.js';
import { ClientsListPage } from './pages/clients-list.js';
import { ClientDetailPage } from './pages/client-detail.js';
import { JobsListPage } from './pages/jobs-list.js';
import { JobDetailPage } from './pages/job-detail.js';
import { CalendarPage } from './pages/calendar.js';

export function App() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/clients" element={<ClientsListPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/jobs" element={<JobsListPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route
          path="*"
          element={
            <div className="page">
              <div className="empty-state">Route not found.</div>
            </div>
          }
        />
      </Routes>
    </AppLayout>
  );
}
